import Counter from "../Counter/Counter";
import styles from "./ToppingTile.module.scss";

interface ToppingTileProps {
  name: string;
  /** Already formatted, e.g. "+ 3.00 zł" — the price of one. */
  price: string;
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  max?: number;
}

/**
 * A selectable extra with its own quantity, so a guest can order two portions
 * of cheese. Quantity 0 means "not chosen"; the stepper is the only control,
 * so there is no ambiguity between tapping the row and tapping a button.
 */
function ToppingTile(props: ToppingTileProps) {
  const { name, price, quantity, onQuantityChange, max = 20 } = props;

  return (
    <div
      className={`${styles.toppingTileContainer} ${
        quantity > 0 ? styles.toppingTileSelected : ""
      }`}
    >
      <div className={styles.toppingTileTextGroup}>
        <p className={`body-bold-medium ${styles.toppingTileName}`}>{name}</p>
        <p className={`body-medium ${styles.toppingTilePrice}`}>{price}</p>
      </div>
      <Counter
        value={quantity}
        onChange={onQuantityChange}
        min={0}
        max={max}
      />
    </div>
  );
}

export default ToppingTile;
